<template>
    <div class="usage">
        <div class="left">
            <img src="@/assets/img/icon/u2417.svg" alt="" />
            <span class="usageTitle">空间使用情况：</span>
        </div>
        <div class="left" style="margin: 27px 25px 0 0;line-height: normal;">
            <div>
                已使用<span v-text="usedSpace"></span> / 总量<span
                    v-text="totalSpace"
                ></span>
            </div>
            <Progress
                :percent="percent"
                :stroke-color="['#059EFF', '#65FEFF']"
                :stroke-width="5"
                hide-info
            />
        </div>
        <div class="left">
            <img src="@/assets/img/icon/u2416.svg" alt="" />
            <span class="usageTitle">使用流量情况：</span>
            已使用<span v-text="usedFlow"></span> / 月总量<span
                v-text="totalFlow"
            ></span>
        </div>
    </div>
</template>

<script>
import { usage } from "@/requests/threeTierMission";
import { bytesToSize } from "@/utils/byte.js";
export default {
    name: "usage",
    components: {},
    data() {
        return {
            usedSpace: "",
            totalSpace: "",
            usedFlow: "",
            totalFlow: "",
            percent: 45,
        };
    },
    methods: {
        async getUsage() {
            let res = await usage();
            this.usedSpace = bytesToSize(res.data.usedSpace);
            this.totalSpace = bytesToSize(res.data.totalSpace);
            this.usedFlow = bytesToSize(res.data.usedFlow);
            this.totalFlow = bytesToSize(res.data.totalFlow);
            this.percent =
                Math.floor((res.data.usedSpace / res.data.totalSpace) * 10000) /
                100;
        },
    },
};
</script>

<style lang="scss" scoped>
.usage {
    float: left;
    margin-left: 10%;
    font-size: 12px;
    .left {
        float: left;
        .usageTitle {
            color: rgb(161, 161, 161);
        }
        img {
            position: relative;
            top: 2px;
            margin-right: 5px;
        }
        div {
            line-height: normal;
        }
    }
}
</style>
<style lang="scss">
.ivu-progress-inner {
    background: #515151;
}
</style>
